import React, { useMemo } from "react";
import styles from "./style.module.scss";

function dayKey(iso, tz) {
  return new Intl.DateTimeFormat("en-CA", { timeZone: tz, year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date(iso));
}

function dayTitle(iso, tz, locale) {
  return new Intl.DateTimeFormat(locale, { timeZone: tz, weekday: "long", day: "numeric", month: "long" }).format(new Date(iso));
}

function timeLabel(iso, tz, locale) {
  return new Intl.DateTimeFormat(locale, { timeZone: tz, hour: "2-digit", minute: "2-digit" }).format(new Date(iso));
}

/** Open times grouped by day in the business's time zone. onPick makes them buttons. */
const SlotPicker = ({ slots, tz, selected, onPick, emptyText, locale }) => {
  const days = useMemo(() => {
    const grouped = new Map();
    (slots || []).forEach((slot) => {
      const key = dayKey(slot.start, tz);
      if (!grouped.has(key)) grouped.set(key, []);
      grouped.get(key).push(slot);
    });
    return Array.from(grouped.values());
  }, [slots, tz]);

  if (!days.length) return <p className={styles.empty}>{emptyText}</p>;
  return (
    <div className={styles.slotDays}>
      {days.map((daySlots) => (
        <div key={daySlots[0].start} className={styles.slotDay}>
          <div className={styles.slotDayTitle}>{dayTitle(daySlots[0].start, tz, locale)}</div>
          <div className={styles.slotList}>
            {daySlots.map((slot) =>
              onPick ? (
                <button
                  key={slot.start}
                  type="button"
                  className={selected === slot.start ? styles.slotOn : styles.slot}
                  aria-pressed={selected === slot.start}
                  onClick={() => onPick(slot.start)}
                >
                  {timeLabel(slot.start, tz, locale)}
                </button>
              ) : (
                <span key={slot.start} className={styles.slotStatic}>
                  {timeLabel(slot.start, tz, locale)}
                </span>
              )
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default SlotPicker;
